export default __webpack_public_path__ + "static/media/department_manager.e2b1f243.png";